import { isEmptyObject } from 'util/object';
import {
  CREATE_OPERATOR_ERROR,
  CREATE_OPERATOR_REQUEST,
  CREATE_OPERATOR_SUCCESS,
  DELETE_OPERATORS_FAIL,
  DELETE_OPERATORS_REQUEST,
  DELETE_OPERATORS_SUCCESS,
  GET_OPERATORS_FAIL,
  GET_OPERATORS_REQUEST,
  GET_OPERATORS_SUCCESS,
  UPDATE_OPERATORS_FAIL,
  UPDATE_OPERATORS_REQUEST,
  UPDATE_OPERATORS_SUCCESS
} from './action';
import * as mutations from './mutations';
import * as queries from './queries';

export function fetchOperationsList(payload) {
  const {
    page,
    limit,
    filters: { machineIds }
  } = payload;
  const parsedFilters = {
    machineIds: machineIds?.length ? machineIds : undefined
  };

  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: GET_OPERATORS_REQUEST });
      const clientResponse = await client.query({
        query: queries.fetchOperationsList,
        variables: {
          pagingOptions: {
            page,
            size: limit
          },
          ...(!isEmptyObject(parsedFilters) && { filter: parsedFilters })
        }
      });
      dispatch({
        type: GET_OPERATORS_SUCCESS,
        payload: clientResponse
      });
    } catch (error) {
      dispatch({ type: GET_OPERATORS_FAIL, payload: { error } });
    }
  };
}

export function deleteOperator(payload) {
  const { id } = payload;

  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: DELETE_OPERATORS_REQUEST, payload: { id } });
      await client.mutate({
        mutation: mutations.deleteOperator,
        variables: {
          input: {
            id
          }
        }
      });
      dispatch({ type: DELETE_OPERATORS_SUCCESS, payload: { id } });
    } catch {
      dispatch({ type: DELETE_OPERATORS_FAIL, payload: { id } });
    }
  };
}

export function updateOperator(id, payload) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: UPDATE_OPERATORS_REQUEST, payload: { id } });
      await client.mutate({
        mutation: mutations.updateOperator,
        variables: {
          input: {
            id,
            patch: payload
          }
        }
      });
      dispatch({ type: UPDATE_OPERATORS_SUCCESS, payload: { id } });
    } catch {
      dispatch({ type: UPDATE_OPERATORS_FAIL, payload: { id } });
    }
  };
}

export function createOperator(OperatorData) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: CREATE_OPERATOR_REQUEST });
      const payload = await client.mutate({
        mutation: mutations.createOperator,
        variables: {
          input: OperatorData
        }
      });
      dispatch({ type: CREATE_OPERATOR_SUCCESS, payload });
    } catch {
      dispatch({ type: CREATE_OPERATOR_ERROR });
    }
  };
}
